import classNames from "classnames";

import "./Spinner.css";

interface SpinnerProps {
  className?: string;
  width?: string;
  height?: string;
}
const Spinner = ({
  className,
  width = "1.25rem",
  height = "1.25rem",
}: Readonly<SpinnerProps>) => {
  return (
    <span
      className={classNames("ica-spinner", className)}
      style={{ width, height }}
    />
  );
};

export default Spinner;
